export const errors = {
  somethingWentWrong: "Κάτι πήγε στραβά",
  tryAgain: "Δοκιμάστε ξανά",
  errorFetchingData: "Σφάλμα κατά τη λήψη δεδομένων",
};
